export interface ILocation {
  region: string;
  state: string;
  city: string;
  latitude: string;
  zip: string;
  longitude: string;
}

export interface UnitCreationData {
  location: ILocation;
  name: string;
  royalties: number;
  taxRegime: string;
  v4Email: string;
  contractSignatureDate: Date;
  contract?: File;
  contractUrl?: string;
  fantasyName: string;
  socialName: string;
  cnpj: string;
  companyNumber: string;
  error?: string;
  address: {
    zipCode: string;
    state: string;
    city: string;
    street: string;
    district: string;
    number: string;
    complement?: string;
  };
  stakeholders: {
    name: string;
    email: string;
    rg: string;
    cpf: string;
    isPrincipal: boolean;
    phone?: string;
  }[];
}

export interface AddressInfo {
  key: string;
  label: string;
  isChecked: boolean;
}

export interface CepInfo {
  street: string;
  district: string;
  city: string;
  state: string;
  location: {
    coordinates: {
      longitude: string;
      latitude: string;
    };
  };
}

export interface UrlInfo {
  url: string;
}

export const dedicationOptions = [
  { key: 'dedicated', label: 'Dedicado', isChecked: false },
  { key: 'shared', label: 'Compartilhado', isChecked: false },
];

export function bytesToMB(bytes: number): number {
  return bytes / (1024 * 1024);
}
